import { useState, useContext } from "react";
import {
  FaFacebookF,
  // FaPhoneAlt,
  FaEnvelope,
  FaLinkedinIn,
  FaInstagram,
  FaTiktok,
  FaYoutube,
  FaWhatsapp,
} from "react-icons/fa";
import { Link, NavLink } from "react-router-dom";
import Sidebar from "../../../components/Sidebar/Sidebar";
import useGlobalContext from "../../../hooks/useGlobalContext";

// import useAnalyticsEventTracker from '../../../services/useAnalyticsEventTracker';
import WhatsAppFab from '../../../components/WhatsAppFab/WhatsAppFab';
import { businessLogic } from "../../../lib/constants";
import { useTranslation } from "react-i18next";
import { trackConversion } from "../../../lib/analytics";

// import { AppContext } from "../../../context/AllContext";
// const { handleTrans } = AppContext();

import { AppContext } from '../../../context/AllContext';


// const lngs = [
//   { code: "en", native: "English" },
//   { code: "es", native: "Spanish" },
// ];



const HomeOneHeader = ({
  textColor = "white",
  logoVariant = "white",
}) => {
  const { handleTrans } = useContext(AppContext);
  const { t } = useTranslation();


  
  // const handleTrans = (code) => {
  //   i18n.changeLanguage(code);
  // };

  // const gaEventTracker = useAnalyticsEventTracker('Contact us');

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const { stickyMenu } = useGlobalContext();

  // #6A60F0 es la variante accesible del morado de marca ($theme-color-text en
  // el SCSS): el #7C74FF original daba 3,62:1 sobre el fondo blanco del header
  // y no llegaba al 4,5:1 de WCAG AA. Se sigue aceptando "#7c74ff" como valor
  // de entrada para no romper las llamadas que ya existían.
  const resolvedTextColor =
    textColor === "purple" ? "#6A60F0" : textColor || "#ffffff";

  const logoSrc =
    logoVariant === "purple"
      ? businessLogic.logoBlack
      : businessLogic.logoWhite;

  const logoStickySrc =
    logoVariant === "purple"
      ? businessLogic.logoBlack
      : businessLogic.logoBlack;

  const headerStyle = { "--header-text-color": resolvedTextColor };
  return (
    <>
      <header>
        <div
          className="header__area p-relative header__transparent header__custom"
          style={headerStyle}
        >
          <div className="d-none d-md-block">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-xl-6 col-lg-5 col-md-4">



                {/* <div style={{padding: '50px'}}>
                  {lngs.map((lng, i) => {
                    const { code, native } = lng;
                    return <button onClick={() => handleTrans(code)}>{native}</button>;
                    
                  })}
                </div> */}



                  <div className="header__social">
                    <ul>


                    <li>
                        <a href={`${businessLogic.linkedin}`} target="_blank" rel="noreferrer">
                          <i>
                            <FaLinkedinIn />
                          </i>
                        </a>
                      </li>


                      <li>
                        <a href={`${businessLogic.instagram}`} target="_blank" rel="noreferrer">
                          <i>
                            <FaInstagram />{" "}
                          </i>
                        </a>{" "}
                      </li>


                      <li>
                        <a href={`${businessLogic.facebook}`} target="_blank" rel="noreferrer">
                          <i>
                            <FaFacebookF />
                          </i>{" "}
                        </a>
                      </li>

                                            <li>
                        <a href={`${businessLogic.tiktok}`} target="_blank" rel="noreferrer">
                          <i>
                            <FaTiktok />
                          </i>{" "}
                        </a>

                        <a href={`${businessLogic.youtube}`} target="_blank" rel="noreferrer">
                          <i>
                            <FaYoutube />
                          </i>{" "}
                        </a>


                      </li>

                      <li>
                        <a
                          href={businessLogic.whatsappCommunityLink}
                          target="_blank"
                          rel="noreferrer"
                          aria-label="WhatsApp Community"
                          title="WhatsApp Community"
                        >
                          <i>
                            <FaWhatsapp />
                          </i>
                        </a>
                      </li>





                      {/* {lngs.map((lng, i) => {
                    const { code, native } = lng;
                    return <button onClick={() => handleTrans(code)}>{native}</button>;
                  })} */}





                    </ul>
                  </div>
                </div>
                <div className="col-xl-6 col-lg-7 col-md-8">
                  <div className="header__info f-right">
                    <ul>
                      {businessLogic.phoneNumber ? (
                      <li>
                        <a href={`tel:${businessLogic.phoneNumber}`}>
                          <i>
                            {" "}
                            {/* <FaPhoneAlt />{" "} */}
                          </i>
                          {businessLogic.phoneNumber}
                        </a>
                      </li>
                      ) : null}
                      <li>
                        <a href={`mailto:${businessLogic.emailBase}`} >
                        {/* <a href={`mailto:${businessLogic.emailBase}`} onClick={()=>gaEventTracker('email')}> */}
                          <i>
                            {" "}
                            <FaEnvelope />{" "}
                          </i>
                          {businessLogic.emailBase}
                        </a>
                      </li>


                      <li>
                        <div className="language__newsletter">
                          {/* <input type="hidden" name="language" id="languageField" value="" /> */}
                            <img onClick={() => handleTrans("es")} src="/assets/img/icon/flags/spain_rounded.png" alt="Spanish" id="spanishFlag" className="flag" style={{cursor:'pointer'}} />
                              <label>&nbsp;&nbsp;</label>
                            <img onClick={() => handleTrans("en")}  src="/assets/img/icon/flags/usa.png" alt="English" id="englishFlag" className="flag" style={{cursor:'pointer'}}/>
                        </div>
                      </li>








                      {/* <li>
                        <a href="#" className="search-toggle">
                          <i>
                            {" "}
                            <FaSearch />{" "}
                          </i>
                        </a>
                      </li> */}


                    </ul>
                  </div>
                </div>
              </div>
                            
            </div>
          </div>
          <div
            id="header__sticky"
            className={stickyMenu ? "sticky header__bottom" : "header__bottom"}
          >
            <div className="container">
              <div className="row align-items-center">
                <div className="col-xl-3 col-lg-3 col-md-6 col-sm-6 col-6">
                  <div className="logo">
                    <NavLink to="/">
                      <img
                        src={`/assets/img/logo/${logoSrc}`}
                        alt="logo"
                        style={{ height: 35 }}
                      />
                    </NavLink>
                  </div>
                  <div className="logo-gradient">
                    <NavLink to="/">
                      <img
                        src={`/assets/img/logo/${logoStickySrc}`}
                        alt="logo"
                        style={{ height: 35 }}
                      />
                    </NavLink>
                  </div>
                </div>
                <div className="col-xl-9 col-lg-9 col-md-6 col-sm-6 col-6">
                  <div className="header__bottom-right d-flex justify-content-end align-items-center">
                    <div className="main-menu menu_wrapper_one">
                      <nav id="mobile-menu">
                        <ul>


                          {/* <li><NavLink to="/home">{t("navbar_home")}</NavLink> */}

                            {/* <ul className="submenu">
                                <li><NavLink to="/home">Home Style 1</NavLink></li>
                                <li>
                                  <NavLink to="/homeTwo">Home Style 2</NavLink>
                                  <ul className="submenu">
                                      <li><NavLink to="/home">Home Style 1</NavLink></li>
                                      <li><NavLink to="/homeTwo">Home Style 2</NavLink></li>
                                      <li><NavLink to="/homeThree">Home Style 3</NavLink></li>
                                  </ul>
                                </li>
                                <li>
                                  <NavLink to="/homeThree">Home Style 3</NavLink>
                                  <ul className="submenu">
                                      <li><NavLink to="/headerStyleFour">Header Syle 4</NavLink></li>
                                      <li><NavLink to="/headerStyleFive">Header Syle 5</NavLink></li>
                                      <li><NavLink to="/headerStyleSix">Header Syle 6</NavLink></li>
                                      <li><NavLink to="/headerStyleSeven">Header Syle 7</NavLink></li>
                                  </ul>
                                </li>
                            </ul> */}
                            
                          {/* </li> */}



                          <li>
                            <NavLink to="/about">{t("navbar_about_us")}</NavLink>
                                        {/* <h1>{t("welcome")}</h1> */}

                          </li>








                          {/* <li>
                            <NavLink to="/core">Planes</NavLink>
                            <ul className="submenu">
                              <li>
                                <NavLink to="/core">Pre Seed</NavLink>
                                <ul className="submenu">
                                  <li><strong>Our Free plan</strong></li>
                                  <li>Perfect for starting your journey with no commitments.</li>
                                </ul>
                              </li>
                              <li>
                                <NavLink to="/core">Seed</NavLink>
                                <ul className="submenu">
                                  <li><strong>Our Basic plan</strong></li>
                                  <li>Get essential tools to fuel your business growth.</li>
                                </ul>
                              </li>
                              <li>
                                <NavLink to="/core">Growth</NavLink>
                                <ul className="submenu">
                                  <li><strong>Our Medium plan</strong></li>
                                  <li>Scale your operations with advanced integrations and support.</li>
                                </ul>
                              </li>
                              <li>
                                <NavLink to="/core">Scale Up</NavLink>
                                <ul className="submenu">
                                  <li><strong>Our Premium plan</strong></li>
                                  <li>For businesses ready to dominate their market.</li>
                                </ul>
                              </li>
                              <li>
                                <NavLink to="/core">Maturity</NavLink>
                                <ul className="submenu">
                                  <li><strong>Our Custom Plan</strong></li>
                                  <li>Tailored solutions for large enterprises with unique needs.</li>
                                </ul>
                              </li>
                            </ul>
                          </li> */}











                          <li>
                            <NavLink to="/services">{t("navbar_services")}</NavLink>
                            {/* <ul className="submenu">
                              <li>
                                <NavLink to="/services">Services</NavLink>
                              </li>
                              <li>
                                <NavLink to="/servicesDetails">
                                  Services Details
                                </NavLink>
                              </li>
                            </ul> */}
                          </li>





                          {/* PORTFOLIO DETAILS IS PERFECT TO USE FOR FAQs */}
                          {/* PORTFOLIO DETAILS IS PERFECT TO USE FOR FAQs */}
                          {/* PORTFOLIO DETAILS IS PERFECT TO USE FOR FAQs */}
                          {/* PORTFOLIO DETAILS IS PERFECT TO USE FOR FAQs */}
                          {/* PORTFOLIO DETAILS IS PERFECT TO USE FOR FAQs */}
                          {/* PORTFOLIO DETAILS IS PERFECT TO USE FOR FAQs */}

                          {/* Marca Blanca: entrada OCULTA del navbar (la ruta /activation sigue activa) */}









                          {/* <li>
                            <NavLink to="/resources">{t("navbar_resources")}</NavLink>
                          </li> */}






                          <li>
                            <NavLink to="/get-started">{t("gs_page_title")}</NavLink>
                          </li>

                          <li>
                            <NavLink to="/playbooks">Playbooks</NavLink>
                          </li>



                          {/* <li>
                            <NavLink to="/pricing">{t("home_footer_platform_pricing")}</NavLink>
                          </li> */}




                          <li>
                            <a href="/blog">{t("navbar_blog")}</a>
                            {/* <ul className="submenu">
                              <li>
                                <NavLink to="/blogs">Blog</NavLink>
                              </li>
                              <li>
                                <NavLink to="/blogDetails">
                                  Blog Details
                                </NavLink>
                              </li>
                            </ul> */}
                          </li>



                        </ul>
                      </nav>
                    </div>
                    <div className="header__btn d-none d-sm-block d-lg-none d-xl-block ml-50">
                      {/* <Link to="/contact" className="z-btn z-btn-white" onClick={()=>gaEventTracker('call')}> */}
                      <div style={{ display: "inline-flex", alignItems: "center", gap: 12 }}>
                        
                        
                        
                        <Link
                          key="demo"
                          to={'/demo'}
                          className="z-btn z-btn-3"
                          onClick={() => trackConversion("Banner CTA Demo")}
                        >
                          {t('demo_cta')}
                        </Link>
                        


                      </div>
                    </div>
                    <div
                      onClick={handleShow}
                      className="sidebar__menu d-lg-none"
                    >
                      <div className="sidebar-toggle-btn" id="sidebar-toggle">
                        <span className="line"></span>
                        <span className="line"></span>
                        <span className="line"></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>


          {/* <div className="header__search-wrapper">
            <div className="container">
              <div className="row">
                <div className="col-xl-12">
                  <form action="#">
                    <input type="text" placeholder="Your Keywords" />
                    <button type="button">
                      <i>
                        {" "}
                        <p></p>
                        <FaSearch />{" "}
                      </i>
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div> */}


          <div className="body-overlay-2"></div>
        </div>



      </header>

      {/* Sustituye al boton de WhatsApp que estaba en el appbar */}
      <WhatsAppFab />

      <Sidebar show={show} handleClose={handleClose} />
    </>
  );
};

export default HomeOneHeader;

















